import { HttpInterceptorFn, HttpResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { VersionUpdateService } from '@app/core/services/version-update.service';
import { tap } from 'rxjs';

const energyConnectVersionHeader = 'X-EnergyConnect-Version';

function isApplicationApiRequest(url: string): boolean {
  return url.startsWith('/api/');
}

export const versionUpdateInterceptor: HttpInterceptorFn = (req, next) => {
  const versionUpdateService = inject(VersionUpdateService);

  return next(req).pipe(
    tap(event => {
      if (!(event instanceof HttpResponse) || !isApplicationApiRequest(req.url)) {
        return;
      }

      versionUpdateService.inspectServedVersion(event.headers.get(energyConnectVersionHeader));
    })
  );
};
